export const debounce = function (func: (...args: any[]) => void, delay: number) {
  let timer: NodeJS.Timeout
  return function (...args: any[]) {
    // @ts-expect-error - this is not typed
    const context = this
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(context, args)
    }, delay)
  }
}
